// Generated types for SysMLUnit
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from '../../shared/types/neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from '../../shared/types/neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLUnitReadAPI extends NeoNodeReadAPI {
  /** Unit symbol (e.g., 'm', 'kg', 'N', 'm/s^2') */
  symbol: string;
  /** Full unit name (e.g., 'meter', 'kilogram', 'newton') */
  name: string;
  /** Dimensional vector: {'L':1, 'M':0, 'T':-1} = Length^1 Time^-1 (velocity) */
  dimension_vector?: Record<string, number>;
  /** Conversion factor to base SI unit */
  conversion_factor?: number | null;
  /** Conversion offset (for temperature scales) */
  conversion_offset?: number | null;
}

export interface SysMLUnitWriteAPI extends NeoNodeWriteAPI {
  /** Unit symbol (e.g., 'm', 'kg', 'N', 'm/s^2') */
  symbol: string;
  /** Full unit name (e.g., 'meter', 'kilogram', 'newton') */
  name: string;
  /** Dimensional vector: {'L':1, 'M':0, 'T':-1} = Length^1 Time^-1 (velocity) */
  dimension_vector?: Record<string, number>;
  /** Conversion factor to base SI unit */
  conversion_factor?: number | null;
  /** Conversion offset (for temperature scales) */
  conversion_offset?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLUnitReadAPISchema: z.ZodType<SysMLUnitReadAPI> = NeoNodeReadAPISchemaObject.extend({
  symbol: z.string(),
  name: z.string(),
  dimension_vector: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.number())).optional(),
  conversion_factor: z.number().nullable().optional(),
  conversion_offset: z.number().nullable().optional(),
}).passthrough();

export const SysMLUnitWriteAPISchema: z.ZodType<SysMLUnitWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  symbol: z.string(),
  name: z.string(),
  dimension_vector: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.number())).optional(),
  conversion_factor: z.number().nullable().optional(),
  conversion_offset: z.number().nullable().optional(),
}).passthrough();
